<script lang="ts">
  export let selectValue: (vintage: string) => void;
  export let selectedValue: string | number;
  export let values: string[] = [];
  export let dataTestId: string = "button-input-group";

</script>

<style>
  .button-group > button:focus {
    outline: none;
    box-shadow: none;
  }

</style>

<div class="fizz-flex-row-0 fizz-flex-wrap button-group" style="--gap: 8px">
  {#each values as value}
    <button
      data-testid={`${dataTestId}-${value}${selectedValue === value ? "-selected" : ""}`}
      on:click={() => selectValue(value)}
      class={selectedValue === value ? "fizz-button-secondary" : "fizz-button"}
    >
      {value}
    </button>
  {/each}
</div>
